"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Figure = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var image_1 = __importDefault(require("next/image"));
// import { useInView } from 'react-intersection-observer'
var styled_components_1 = __importDefault(require("styled-components"));
var Video_1 = require("./Video");
var hooks_1 = require("../../hooks");
var FigureStyled = styled_components_1.default.figure(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  position: relative;\n"], ["\n  display: block;\n  position: relative;\n"])));
exports.Figure = (0, react_1.memo)(function (_a) {
    var _b, _c;
    var media = _a.media, _d = _a.lazy, lazy = _d === void 0 ? true : _d, _e = _a.layout, layout = _e === void 0 ? 'fill' : _e, _f = _a.onClick, onClick = _f === void 0 ? null : _f, _g = _a.className, className = _g === void 0 ? '' : _g, _h = _a.initialInView, initialInView = _h === void 0 ? false : _h, _j = _a.outRef, outRef = _j === void 0 ? null : _j, _k = _a.blur, blur = _k === void 0 ? false : _k, _l = _a.sizes, sizes = _l === void 0 ? '70vw' : _l, _m = _a.quality, quality = _m === void 0 ? 75 : _m, _o = _a.oldVersion, oldVersion = _o === void 0 ? false : _o, _p = _a.playsinline, playsinline = _p === void 0 ? false : _p;
    var mediaType = (0, hooks_1.useMediaType)();
    // const [ref, inView] = useInView({
    //   triggerOnce: true,
    //   rootMargin: '200px 0px', // TOP  RIGHT
    //   threshold: 0,
    //   initialInView
    // })
    // console.log('initialInView', initialInView)
    if ((media === null || media === void 0 ? void 0 : media.type) === 'video')
        return (0, jsx_runtime_1.jsx)(Video_1.Video, { data: media, playsinline: playsinline });
    if (!((_b = media === null || media === void 0 ? void 0 : media.default) === null || _b === void 0 ? void 0 : _b.src))
        return (0, jsx_runtime_1.jsx)("div", { className: 'placeholder' });
    // ref={ref}
    return ((0, jsx_runtime_1.jsxs)(FigureStyled, __assign({ className: className }, onClick && { onClick: onClick }, outRef && { ref: outRef }, { children: [oldVersion ?
                (0, jsx_runtime_1.jsx)("img", { src: media[(mediaType === 'mobile' && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default'].src, alt: media.alt }) :
                (0, jsx_runtime_1.jsx)(image_1.default, __assign({ src: media[(mediaType === 'mobile' && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default'].src, alt: media.alt, layout: layout }, !lazy && { priority: true }, layout === 'responsive' && { height: (_c = media[(mediaType === 'mobile' && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default'].size.height) !== null && _c !== void 0 ? _c : 500 }, layout === 'responsive' && { width: media[(mediaType === 'mobile' && (media === null || media === void 0 ? void 0 : media.mobile)) ? 'mobile' : 'default'].size.width }, { sizes: sizes }, quality !== 75 && { quality: quality })), blur && (0, jsx_runtime_1.jsx)("div", { className: 'blur' })] })));
});
var templateObject_1;
